import { message } from 'antd';
import { MAX_AUDIO_DURATION, MAX_AUDIO_SIZE, ACCEPT_AUDIO_MIME_TYPES } from "@/constants/fileImport";

/**
 * 验证文件是否符合要求
 * @param file 待验证的文件
 * @param fileUsedCount 已使用的文件数量
 * @param benefit 每日最大上传数量
 * @returns 验证是否通过
 */
export function validateAudioFile(file: File, fileUsedCount: number, benefit: number): boolean {
  // 检查每日上传数量限制
  if (fileUsedCount > benefit) {
    message.destroy();
    message.warning('每日最多上传10个音视频文件');
    return false;
  }

  // 检查文件大小
  if (file.size > MAX_AUDIO_SIZE) {
    message.warning('单个音频文件不超过200M');
    return false;
  }

  // 检查文件格式
  if (!ACCEPT_AUDIO_MIME_TYPES.find(item => file.type.includes(item))) {
    message.warning('文件格式出错');
    return false;
  }

  return true;
}

/**
 * 验证拖拽文件格式
 * @param files 拖拽的文件列表
 */
export function validateDroppedAudioFiles(files: File[]): void {
  files.forEach(file => {
    if (!ACCEPT_AUDIO_MIME_TYPES.find(item => file.type.includes(item))) {
      message.destroy();
      message.warning('文件格式出错');
    }
  });
}

/**
 * 检查音频时长是否符合要求
 * @param duration 音频时长（秒）
 * @returns 是否符合要求
 */
export function validateAudioDuration(duration: number): boolean {
  return duration <= MAX_AUDIO_DURATION;
}
